import { useQuery } from '@tanstack/react-query';
import { fetchRouterTrafficHistory } from '../lib/routerMonitoringApi';
import { routerMonitoringQueryKeys } from '../lib/routerMonitoringQueryKeys';

export const useRouterTrafficHistory = ({ routerId, interfaceName, range = '1h' }) => {
  const minutes = range === '5m' ? 5 : range === '24h' ? 60 * 24 : 60;
  const limit = range === '24h' ? 500 : 240;

  return useQuery({
    queryKey: routerMonitoringQueryKeys.trafficHistory(routerId, { interfaceName: interfaceName || null, range }),
    queryFn: () => fetchRouterTrafficHistory(routerId, { interfaceName, minutes, limit }),
    enabled: Boolean(routerId),
    refetchInterval: false,
  });
};

export default useRouterTrafficHistory;
